import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import SectionTitle from "../SectionTitle/SectionTitle";
import Services, { fetchCategories, fetchAllCategories } from "../../api/Services";
import ImageWithGoogleDrive from "../ImageWithGoogleDrive/ImageWithGoogleDrive";



const ServiceSection = (props) => {
    const { hclass, sliceStart = 0, sliceEnd = 3, showSectionTitle = true, AllServices = true } = props;
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                setLoading(true);
                
                // Determine which API function to use based on props
                // If AllServices is false and sliceEnd > 3, it's the services page
                const isAllServicesPage = !AllServices && sliceEnd > 3;
                console.log('ServiceSection Debug:', { sliceEnd, AllServices, isAllServicesPage });
                
                const apiCategories = isAllServicesPage 
                    ? await fetchAllCategories() 
                    : await fetchCategories();
                
                console.log('API Categories:', apiCategories);
                
                if (apiCategories && apiCategories.length > 0) {
                    // Transform API data to match the expected format
                    const transformedCategories = apiCategories.map(category => ({
                        id: category.id,
                        icon: "flaticon-microsurgery", // Default icon since API doesn't provide icons
                        title: category.name,
                        description: category.description,
                        logo: category.logo,
                        slug: category.name.replace(/\s+/g, '-').toLowerCase(),
                    }));
                    setCategories(transformedCategories);
                } else {
                    // Fallback to static data if API fails
                    console.log('Using fallback data');
                    setCategories(Services);
                }
            } catch (error) {
                console.error('Error loading categories:', error);
                // Fallback to static data on error
                setCategories(Services);
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, [sliceEnd, AllServices]);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
      <section className={hclass}>
        <div className="container">
          {showSectionTitle && (
            <div className="row justify-content-center">
              <div className="col-lg-9 col-12">
                <SectionTitle
                  title={"Especialidades"}
                  subtitle={"Áreas de servicio"}
                />
              </div>
            </div>
          )}
          <div className="row">
            {loading ? (
              // Loading state
              Array.from({ length: sliceEnd - sliceStart }).map((_, index) => (
                <div className="col-lg-4 col-md-6 col-12" key={`loading-${index}`}>
                  <div className="service_card">
                          <div className="icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                       <div className="spinner-border text-primary" role="status">
                         <span className="visually-hidden">Cargando...</span>
                       </div>
                     </div>
                    <div className="content">
                      <h2 className="fs-2">Cargando...</h2>
                      <p>Cargando especialidad...</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              // Render categories from API or fallback
              categories.slice(sliceStart, sliceEnd).map((servic, sky) => (
                <div className="col-lg-4 col-md-6 col-12" key={sky}>
                  <div className="service_card">
                        <div className="icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                       {servic.logo ? (
                         <ImageWithGoogleDrive
                           src={servic.logo} 
                           alt={servic.title} 
                           style={{ 
                             width: '50px', 
                             height: '50px',
                             filter: 'brightness(0) invert(1)', // Convierte a blanco
                           }} 
                         />
                       ) : (
                         <i className={servic.icon}></i>
                       )}
                     </div>
                    <div className="content">
                      <h2 className="fs-2">{servic.title}</h2>
                      <p>{servic.description}</p>
                    </div>
                  </div>
                </div>
              ))
            )}
            {AllServices && !loading && (
              <div className="col-12">
                <div className="btn">
                  <Link
                    onClick={ClickHandler}
                    to={"/services"}
                    className="theme-btn"
                  >
                    Ver todas las especialidades
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
}

export default ServiceSection;




